var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 19H3C1.89543 19 1 18.1046 1 17V10.2969C1 9.78521 1.19615 9.29295 1.54809 8.92146L8.54809 1.53257C9.33695 0.699887 10.663 0.699886 11.4519 1.53257L18.4519 8.92146C18.8038 9.29295 19 9.78521 19 10.2969V17C19 18.1046 18.1046 19 17 19H12M8 19V13.5C8 13.2239 8.22386 13 8.5 13H11.5C11.7761 13 12 13.2239 12 13.5V19M8 19H12",
    stroke: "#1F1F22",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.d1ecb5ceb4081bb5458ca7bdd419ec5c.svg";
export { ForwardRef as ReactComponent };